module.exports = __webpack_public_path__ + "staticcomp/img/top.58260f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/11/top.jpg
// module id = cQVF
// module chunks = 39